module.exports = __webpack_public_path__ + "static/media/test3_4.97c6065c.png";